'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Example Usage:

  <PerformanceMeasure moduleName="axp-xxxxx" variable="xxxxx"/>
*/

var PerformanceMeasure = function (_Component) {
  _inherits(PerformanceMeasure, _Component);

  function PerformanceMeasure() {
    _classCallCheck(this, PerformanceMeasure);

    return _possibleConstructorReturn(this, (PerformanceMeasure.__proto__ || Object.getPrototypeOf(PerformanceMeasure)).apply(this, arguments));
  }

  _createClass(PerformanceMeasure, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          moduleName = _props.moduleName,
          variable = _props.variable,
          children = _props.children;

      try {
        if (window) {
          // Mark will be set when the variable prop holds data.
          if (!window.moduleLoadTimes) {
            window.moduleLoadTimes = {};
          }
          if (variable || variable === 0) {
            if (!window.moduleLoadTimes[moduleName]) {
              var performanceNow = window.performance.now();
              var resourceStartObj = window.performance.getEntriesByType('resource').filter(function (resource) {
                return resource.name.indexOf(moduleName + '.') > -1;
              })[0];
              var resourceStart = resourceStartObj ? resourceStartObj.startTime : 0;
              var loadTime = resourceStart > 0 ? performanceNow - resourceStart : null;
              if (loadTime) {
                window.moduleLoadTimes[moduleName] = {
                  scriptStartTime: resourceStart,
                  dataRendered: performanceNow,
                  loadTime: loadTime
                };
              }
            }
            if (window.performance.mark) {
              window.performance.mark('rum-marker--' + moduleName + '--data-rendered');
            }
          }
        }
      } catch (e) {
        // not empty
      }
      return children;
    }
  }]);

  return PerformanceMeasure;
}(_react.Component);

PerformanceMeasure.propTypes = {
  children: _propTypes2.default.node,
  moduleName: _propTypes2.default.string.isRequired,
  variable: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool])
};

PerformanceMeasure.defaultProps = {
  children: [],
  variable: null
};

exports.default = PerformanceMeasure;
module.exports = exports['default'];